// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"216":"f7e75215","312":"25d9eb3e","392":"579d5aac","658":"e6604ece","676":"4998fbee","708":"0dc8a315","828":"7016959e"}[chunkId] + ".chunk.css";
};